import { QUESTIONS } from "./questions.js";

const STATUS = {
  good: { icon: "✅", label: "Strong" },
  warn: { icon: "⚠️", label: "Needs attention" },
  bad:  { icon: "🔴", label: "At risk" },
};

export function statusForScore(norm) {
  if (norm === null) return null;
  if (norm >= 0.75) return STATUS.good;
  if (norm >= 0.4) return STATUS.warn;
  return STATUS.bad;
}

export function buildFeedback(perQuestion) {
  return perQuestion.map((q) => ({
    shortLabel: q.shortLabel,
    answer: q.answer,
    status: statusForScore(q.normScore),
    normScore: q.normScore,
  }));
}

export function overallBand(score) {
  if (score >= 10) return { band: "Perfect", summary: "You've mastered how to deploy low-code operational software with Airtable." };
  if (score >= 8) return { band: "High", summary: "Your Airtable setup is well-architected. A few tweaks could take it further." };
  if (score >= 5) return { band: "Medium", summary: "You're running on a solid foundation, focus on the areas holding you back." };
  return { band: "Low", summary: "Your Airtable setup has gaps that will slow you down as usage grows." };
}
